export default __webpack_public_path__ + "static/media/services.1af24a3c.svg";